import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddInternalMarks() {
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  const navigate = useNavigate();
  const location = useLocation();
  const focusInputRef = useRef(null); // Ref for the username input
  const { examId, subjectId, subjectName } = location.state || {};
  const [loaded, setLoaded] = useState(false);
  const [selectionType, setSelectionType] = useState('one'); // State to hold "One" or "Many" selection
  const currentPath = location?.pathname || '';
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();
  }, [navigate]);
  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };
  // State to hold form data
  const [formData, setFormData] = useState({
    facultyName: '',
    name: '',
    rollNumber: '',
    subjectMarks: '',
  });

  // Function to fetch student details
  const fetchStudentDetails = async (rollNumber) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${apiUrl}/api/students/getstudent`,
        JSON.stringify({ examId, rollNumber, subjectId }),
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      // Update the student name in the form
      setFormData((prevState) => ({
        ...prevState,
        name: response.data.name || '',
      }));
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      toast.error(error.response.data.message);
    }
  };

  const handleSubmit = (e) => {
    setLoaded(true);
    e.preventDefault();

    const token = localStorage.getItem('token');

    // Make a POST request to add internal marks
    axios
      .post(
        `${apiUrl}/api/internalmarks/`,
        {
          examId,
          subjectId,
          ...formData,
        },
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        // Display success toast and redirect to ListInternalMarks page
        toast.success('Internal marks added successfully');
        focus();
        setLoaded(false);
        // Reset form data to initial state
        setFormData({
          facultyName: '',
          name: '',
          rollNumber: '',
          subjectMarks: '',
        });
        if (selectionType === 'one' && currentPath === '/AddInternalmarks') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/AddInternalmarks') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        console.error('Error adding internal marks:', err);
        toast.error(
          err.response?.data?.message || 'Error adding internal marks'
        );
        setLoaded(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === 'subjectMarks' ? Number(value) : value,
    }));
  };

  // Handle blur event to fetch student details
  const handleRollNumberBlur = () => {
    if (formData.rollNumber) {
      fetchStudentDetails(formData.rollNumber);
    }
  };

  return (
    <>
      <AdminLayout ac7="active">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-3)}>
                    Exams for Internal Marks
                  </span>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-2)}>
                    Subject list
                  </span>
                </li>

                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Internal Marks
                </li>
                <li className="breadcrumb-item active">Add Internal Marks</li>
              </ol>
            </nav>
          </div>
          <section className="section col-lg-112">
            <div className="row">
              <div className="">
                <div className="card">
                  <div className="card-body mt-5 mx-3">
                    <form onSubmit={handleSubmit}>
                      <div className="container">
                        <div className="row row-cols-1">
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                ref={focusInputRef}
                                className="form-control"
                                type="text"
                                name="rollNumber"
                                value={formData.rollNumber}
                                onChange={handleChange}
                                onBlur={handleRollNumberBlur}
                                placeholder="Roll Number"
                                required
                              />
                              <label className="form-label">
                                Roll Number{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Student Name"
                                required
                                disabled={true}
                              />
                              <label className="form-label">
                                Student Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="facultyName"
                                value={formData.facultyName}
                                onChange={handleChange}
                                placeholder="Faculty Name"
                                required
                              />
                              <label className="form-label">
                                Faculty Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="number"
                                name="subjectMarks"
                                value={formData.subjectMarks}
                                onChange={handleChange}
                                placeholder="Subject Marks"
                                required
                                min={0}
                                onWheel={(e) => e.target.blur()}
                              />
                              <label className="form-label">
                                Subject Marks{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="d-flex justify-content-between ">
                          <div className="p-2 mx-1 bd-highlight">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input recode-switch"
                                type="checkbox"
                                id="selectionSwitch"
                                checked={selectionType === 'many'} // Toggle the state
                                onChange={() =>
                                  setSelectionType(
                                    selectionType === 'many' ? 'one' : 'many'
                                  )
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="selectionSwitch"
                              >
                                {selectionType === 'many'
                                  ? 'Many Marks Add'
                                  : 'One Mark Add'}
                              </label>
                            </div>
                          </div>

                          <div className="p-2 mx-1 bd-highlight">
                            <button
                              type="button"
                              className="btn btn-primary px-3"
                              onClick={() => navigate(-1)}
                            >
                              <i className="bi bi-arrow-bar-left"></i> Back
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary px-4 mx-2"
                              disabled={loaded}
                            >
                              {loaded ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>{' '}
                                  Wait...
                                </>
                              ) : (
                                <>Save</>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="col-sm-12 pt-4 text-end"></div>
                      </div>
                    </form>
                    <ToastContainer
                      position="top-center"
                      style={{ width: 'auto' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </AdminLayout>
    </>
  );
}
